/**
 * @author: SuperHorse.马超 machao@meitunmama.com
 * Created on 2019/07/23
 *
 */
export default {
  getIncome: '/newapi/router/ecommerce/lighthouse/earnIncomeList',
  getMyIncome: '/newapi/router/ecommerce/lighthouse/homeCenter', // 获取我的收益数值
  getInvite: '/newapi/router/ecommerce/invite/distributionInvitations',
  lightForPreOrder: '/newapi/router/ecommerce/csorder/getPreOrderInfo',
  lightSubmitOrder: '/newapi/router/ecommerce/csorder/submitOrder',
  getMyOrders: '/newapi/router/ecommerce/lighthouse/myOrders',  // 我的订单列表
  getExamInfo: '/newapi/router/ecommerce/mylisten/getExamInfo',
  submitExam: '/newapi/router/ecommerce/mylisten/submitExam',
  adByCodes: '/newapi/router/cms/advertise/findAdvertiseByCodes',    // cms配置广告位
  getHomePage: '/newapi/router/vipcom/light/homePage', // MAPI-宝树号首页接口
  getMyCourse: '/newapi/router/ecommerce/mylisten/getMyCourses', // MAPI-我的课堂-我的课程列表
  getHomeCoupon: '/newapi/router/ecommerce/lighthouse/grantVoucher', // MAPI-新老拼团用户发券
  getShareMaterial: '/newapi/router/ecommerce/invite/shareMaterial', // MAPI-宝树号获取分享海报素材
  lightCourseDetail: '/newapi/router/health-lighthouse/courseDetail', // 课程详情
  simpleSubCourse: '/newapi/router/health-commonDetail/simpleSubCourse', // 小灯塔 子课详情
  getLighthouseCourseDetail: '/newapi/router/health-lighthouse/courseDetail', // MAPI-小灯塔-课程详情
  getLighthouseCourseList: '/newapi/router/health-lighthouse/subCourseList', // MAPI-小灯塔-子课程列表
  topicCountInfo: '/newapi/router/ecommerce/lighthouse/activityCountInfo', // 拼团汇总信息
  topicGroupInfo: '/newapi/router/ecommerce/lighthouse/activityInstanceInfo', // 拼团实例信息
  orderTipList: '/newapi/router/ecommerce/lighthouse/activityOrderTipList', // 课程详情跑马灯
  coursePrice: '/newapi/router/ecommerce/lighthouse/coursePrice',  // 拼团价格信息
  myCoupon: '/newapi/router/ecommerce/coupon/myCoupon', // 服务电商--我的优惠券列表
  skuList: '/newapi/router/ecommerce/coupon/skuList',  // 立即使用优惠券商品列表
  saveOpenId: '/newapi/router/vipcom/light/saveOpenId'  // 保存openId
};



// WEBPACK FOOTER //
// ./src/comm/api/lighthouse/index.js